import { render, staticRenderFns } from "./SettlementItemsComponent.vue?vue&type=template&id=1d653925&scoped=true&"
import script from "./SettlementItemsComponent.vue?vue&type=script&lang=js&"
export * from "./SettlementItemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettlementItemsComponent.vue?vue&type=style&index=0&id=1d653925&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d653925",
  null
  
)

export default component.exports